import React from 'react';
import { Check, CheckCheck } from 'lucide-react';

export function ReadReceipt({ message, userId, memberCount }) {
  if (message.sender_id !== userId) return null;
  const readByOthers = Object.keys(message.read_by || {}).filter(k => k !== userId).length;
  const otherMembers = memberCount - 1;
  const allRead = otherMembers > 0 && readByOthers >= otherMembers;
  return (
    <span data-testid={`read-receipt-${message.id}`} className="inline-flex ml-1 align-middle">
      {allRead ? (
        <CheckCheck size={12} className="text-blue-200" />
      ) : (
        <Check size={12} className="text-blue-300/60" />
      )}
    </span>
  );
}
